export const portfolio = [
	{
		img: "/excursions/photo11.jpg",
		head: "portfolio.items.1.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo12.jpg",
		head: "portfolio.items.1.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo13.jpg",
		head: "portfolio.items.1.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo21.jpg",
		head: "portfolio.items.2.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo22.jpg",
		head: "portfolio.items.2.title",
		color: "#3a3a3aff",
	},
	{
		img: "/excursions/photo23.jpg",
		head: "portfolio.items.2.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo24.jpg",
		head: "portfolio.items.2.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo31.jpg",
		head: "portfolio.items.3.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo32.jpg",
		head: "portfolio.items.3.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo33.jpg",
		head: "portfolio.items.3.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo34.jpg",
		head: "portfolio.items.3.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo41.jpg",
		head: "portfolio.items.4.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo42.jpg",
		head: "portfolio.items.4.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo43.jpg",
		head: "portfolio.items.4.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo44.jpg",
		head: "portfolio.items.4.title",
		color: "#4d4b48ff",
	},
	{
		img: "/excursions/photo51.jpg",
		head: "portfolio.items.5.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo52.jpg",
		head: "portfolio.items.5.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo53.jpg",
		head: "portfolio.items.5.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo54.jpg",
		head: "portfolio.items.5.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo55.jpg",
		head: "portfolio.items.5.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo61.jpg",
		head: "portfolio.items.6.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo62.jpg",
		head: "portfolio.items.6.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo63.jpg",
		head: "portfolio.items.6.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo64.jpg",
		head: "portfolio.items.6.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo71.jpg",
		head: "portfolio.items.7.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo72.jpg",
		head: "portfolio.items.7.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo73.jpg",
		head: "portfolio.items.7.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo74.jpg",
		head: "portfolio.items.7.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo81.jpg",
		head: "portfolio.items.8.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo82.jpg",
		head: "portfolio.items.8.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo83.jpg",
		head: "portfolio.items.8.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo91.jpg",
		head: "portfolio.items.9.title",
		color: "#363636ff",
	},
	{
		img: "/excursions/photo92.jpg",
		head: "portfolio.items.9.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo93.jpg",
		head: "portfolio.items.9.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo101.jpg",
		head: "portfolio.items.10.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo102.jpg",
		head: "portfolio.items.10.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo103.jpg",
		head: "portfolio.items.10.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo104.jpg",
		head: "portfolio.items.10.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo105.jpg",
		head: "portfolio.items.10.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo111.jpg",
		head: "portfolio.items.11.title",
		color: "#223a23ff",
	},
	{
		img: "/excursions/photo112.jpg",
		head: "portfolio.items.11.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo121.jpg",
		head: "portfolio.items.12.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo122.jpg",
		head: "portfolio.items.12.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo123.jpg",
		head: "portfolio.items.12.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo131.jpg",
		head: "portfolio.items.13.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo132.jpg",
		head: "portfolio.items.13.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo141.jpg",
		head: "portfolio.items.14.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo142.jpg",
		head: "portfolio.items.14.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo143.jpg",
		head: "portfolio.items.14.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo151.jpg",
		head: "portfolio.items.15.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo152.jpg",
		head: "portfolio.items.15.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo161.jpg",
		head: "portfolio.items.16.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo162.jpg",
		head: "portfolio.items.16.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo163.jpg",
		head: "portfolio.items.16.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo171.jpg",
		head: "portfolio.items.17.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo172.jpg",
		head: "portfolio.items.17.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo181.jpg",
		head: "portfolio.items.18.title",
		color: "#223a23ff",
	},
	{
		img: "/excursions/photo182.jpg",
		head: "portfolio.items.18.title",
		color: "#223a23ff",
	},
	{
		img: "/excursions/photo183.jpg",
		head: "portfolio.items.18.title",
		color: "#223a23ff",
	},
	{
		img: "/excursions/photo191.jpg",
		head: "portfolio.items.19.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo192.jpg",
		head: "portfolio.items.19.title",
		color: "#F8F4E9",
	},
	{
		img: "/excursions/photo193.jpg",
		head: "portfolio.items.19.title",
		color: "#F8F4E9",
	},
];

export const reviews = [
	{
		img: "/users/user.svg",
		name: "reviews.1.name",
		excursion: "reviews.1.excursion",
		text: "reviews.1.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.2.name",
		excursion: "reviews.2.excursion",
		text: "reviews.2.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.3.name",
		excursion: "reviews.3.excursion",
		text: "reviews.3.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.4.name",
		excursion: "reviews.4.excursion",
		text: "reviews.4.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.5.name",
		excursion: "reviews.5.excursion",
		text: "reviews.5.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.6.name",
		excursion: "reviews.6.excursion",
		text: "reviews.6.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.7.name",
		excursion: "reviews.7.excursion",
		text: "reviews.7.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.8.name",
		excursion: "reviews.8.excursion",
		text: "reviews.8.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.9.name",
		excursion: "reviews.9.excursion",
		text: "reviews.9.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.10.name",
		excursion: "reviews.10.excursion",
		text: "reviews.10.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.11.name",
		excursion: "reviews.11.excursion",
		text: "reviews.11.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.12.name",
		excursion: "reviews.12.excursion",
		text: "reviews.12.text",
	},
	{
		img: "/users/user.svg",
		name: "reviews.13.name",
		excursion: "reviews.13.excursion",
		text: "reviews.13.text",
	},
];

export const excursions = [
	{
		id: "0",
		img: "/excursions/prechestinka.jpg",
		name: "excursions.1.title",
		age: "excursions.1.age",
		time: "excursions.1.time",
		route: "excursions.1.route",
		desc: "excursions.1.description",
		price: "excursions.1.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.1.details.1",
			},
			{
				text: "excursions.1.details.2",
			},
			{
				text: "excursions.1.details.3",
			},
			{
				text: "excursions.1.details.4",
			},
		],
		what_to_expect: [
			{
				text: "excursions.1.what_to_expect.1",
			},
			{
				text: "excursions.1.what_to_expect.2",
			},
			{
				text: "excursions.1.what_to_expect.3",
			},
			{
				text: "excursions.1.what_to_expect.4",
			},
			{
				text: "excursions.1.what_to_expect.5",
			},
			{
				text: "excursions.1.what_to_expect.6",
			},
			{
				text: "excursions.1.what_to_expect.7",
			},
			{
				text: "excursions.1.what_to_expect.8",
			},
			{
				text: "excursions.1.what_to_expect.9",
			},
			{
				text: "excursions.1.what_to_expect.10",
			},
			{
				text: "excursions.1.what_to_expect.11",
			},
		],
		what_you_learn: [
			{
				text: "excursions.1.what_you_learn.1",
			},
			{
				text: "excursions.1.what_you_learn.2",
			},
			{
				text: "excursions.1.what_you_learn.3",
			},
			{
				text: "excursions.1.what_you_learn.4",
			},
			{
				text: "excursions.1.what_you_learn.5",
			},
			{
				text: "excursions.1.what_you_learn.6",
			},
		],
	},
	{
		id: "1",
		img: "/excursions/ukraine_hotel.jpg",
		name: "excursions.2.title",
		age: "excursions.2.age",
		time: "excursions.2.time",
		route: "excursions.2.route",
		desc: "excursions.2.description",
		price: "excursions.2.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.2.details.1",
			},
			{
				text: "excursions.2.details.2",
			},
			{
				text: "excursions.2.details.3",
			},
			{
				text: "excursions.2.details.4",
			},
			{
				text: "excursions.2.details.5",
			},
			{
				text: "excursions.2.details.6",
			},
		],
		what_to_expect: [
			{
				text: "excursions.2.what_to_expect.1",
			},
			{
				text: "excursions.2.what_to_expect.2",
			},
			{
				text: "excursions.2.what_to_expect.3",
			},
			{
				text: "excursions.2.what_to_expect.4",
			},
			{
				text: "excursions.2.what_to_expect.5",
			},
			{
				text: "excursions.2.what_to_expect.6",
			},
			{
				text: "excursions.2.what_to_expect.7",
			},
			{
				text: "excursions.2.what_to_expect.8",
			},
		],
		what_you_learn: [
			{
				text: "excursions.2.what_you_learn.1",
			},
			{
				text: "excursions.2.what_you_learn.2",
			},
			{
				text: "excursions.2.what_you_learn.3",
			},
			{
				text: "excursions.2.what_you_learn.4",
			},
			{
				text: "excursions.2.what_you_learn.5",
			},
			{
				text: "excursions.2.what_you_learn.6",
			},
		],
	},
	{
		id: "2",
		img: "/excursions/red_square_game.jpg",
		name: "excursions.3.title",
		age: "excursions.3.age",
		time: "excursions.3.time",
		route: "excursions.3.route",
		desc: "excursions.3.description",
		price: "excursions.3.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.3.details.1",
			},
			{
				text: "excursions.3.details.2",
			},
			{
				text: "excursions.3.details.3",
			},
			{
				text: "excursions.3.details.4",
			},
			{
				text: "excursions.3.details.5",
			},
		],
		what_to_expect: [
			{
				text: "excursions.3.what_to_expect.1",
			},
			{
				text: "excursions.3.what_to_expect.2",
			},
			{
				text: "excursions.3.what_to_expect.3",
			},
			{
				text: "excursions.3.what_to_expect.4",
			},
			{
				text: "excursions.3.what_to_expect.5",
			},
			{
				text: "excursions.3.what_to_expect.6",
			},
			{
				text: "excursions.3.what_to_expect.7",
			},
			{
				text: "excursions.3.what_to_expect.8",
			},
			{
				text: "excursions.3.what_to_expect.9",
			},
			{
				text: "excursions.3.what_to_expect.10",
			},
		],
		what_you_learn: [
			{
				text: "excursions.3.what_you_learn.1",
			},
			{
				text: "excursions.3.what_you_learn.2",
			},
			{
				text: "excursions.3.what_you_learn.3",
			},
			{
				text: "excursions.3.what_you_learn.4",
			},
			{
				text: "excursions.3.what_you_learn.5",
			},
			{
				text: "excursions.3.what_you_learn.6",
			},
			{
				text: "excursions.3.what_you_learn.7",
			},
			{
				text: "excursions.3.what_you_learn.8",
			},
		],
	},
	{
		id: "3",
		img: "/excursions/novodevichy_convent.jpg",
		name: "excursions.4.title",
		age: "excursions.4.age",
		time: "excursions.4.time",
		route: "excursions.4.route",
		desc: "excursions.4.description",
		price: "excursions.4.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.4.details.1",
			},
			{
				text: "excursions.4.details.2",
			},
			{
				text: "excursions.4.details.3",
			},
			{
				text: "excursions.4.details.4",
			},
			{
				text: "excursions.4.details.5",
			},
			{
				text: "excursions.4.details.6",
			},
		],
		what_to_expect: [
			{
				text: "excursions.4.what_to_expect.1",
			},
			{
				text: "excursions.4.what_to_expect.2",
			},
			{
				text: "excursions.4.what_to_expect.3",
			},
			{
				text: "excursions.4.what_to_expect.4",
			},
			{
				text: "excursions.4.what_to_expect.5",
			},
			{
				text: "excursions.4.what_to_expect.6",
			},
		],
		what_you_learn: [
			{
				text: "excursions.4.what_you_learn.1",
			},
			{
				text: "excursions.4.what_you_learn.2",
			},
			{
				text: "excursions.4.what_you_learn.3",
			},
			{
				text: "excursions.4.what_you_learn.4",
			},
		],
	},
	{
		id: "4",
		img: "/excursions/stalin_skyscrapers.jpg",
		name: "excursions.5.title",
		age: "excursions.5.age",
		time: "excursions.5.time",
		route: "excursions.5.route",
		desc: "excursions.5.description",
		price: "excursions.5.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.5.details.1",
			},
			{
				text: "excursions.5.details.2",
			},
		],
		what_to_expect: [
			{
				text: "excursions.5.what_to_expect.1",
			},
			{
				text: "excursions.5.what_to_expect.2",
			},
			{
				text: "excursions.5.what_to_expect.3",
			},
			{
				text: "excursions.5.what_to_expect.4",
			},
			{
				text: "excursions.5.what_to_expect.5",
			},
			{
				text: "excursions.5.what_to_expect.6",
			},
			{
				text: "excursions.5.what_to_expect.7",
			},
			{
				text: "excursions.5.what_to_expect.8",
			},
			{
				text: "excursions.5.what_to_expect.9",
			},
			{
				text: "excursions.5.what_to_expect.10",
			},
		],
		what_you_learn: [
			{
				text: "excursions.5.what_you_learn.1",
			},
			{
				text: "excursions.5.what_you_learn.2",
			},
			{
				text: "excursions.5.what_you_learn.3",
			},
			{
				text: "excursions.5.what_you_learn.4",
			},
			{
				text: "excursions.5.what_you_learn.5",
			},
			{
				text: "excursions.5.what_you_learn.6",
			},
			{
				text: "excursions.5.what_you_learn.7",
			},
			{
				text: "excursions.5.what_you_learn.8",
			},
			{
				text: "excursions.5.what_you_learn.9",
			},
			{
				text: "excursions.5.what_you_learn.10",
			},
		],
	},
	{
		id: "5",
		img: "/excursions/vdnh.jpg",
		name: "excursions.6.title",
		age: "excursions.6.age",
		time: "excursions.6.time",
		route: "excursions.6.route",
		desc: "excursions.6.description",
		price: "excursions.6.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.6.details.1",
			},
			{
				text: "excursions.6.details.2",
			},
			{
				text: "excursions.6.details.3",
			},
			{
				text: "excursions.6.details.4",
			},
			{
				text: "excursions.6.details.5",
			},
			{
				text: "excursions.6.details.6",
			},
			{
				text: "excursions.6.details.7",
			},
		],
		what_to_expect: [
			{
				text: "excursions.6.what_to_expect.1",
			},
			{
				text: "excursions.6.what_to_expect.2",
			},
			{
				text: "excursions.6.what_to_expect.3",
			},
			{
				text: "excursions.6.what_to_expect.4",
			},
		],
		what_you_learn: [
			{
				text: "excursions.6.what_you_learn.1",
			},
			{
				text: "excursions.6.what_you_learn.2",
			},
			{
				text: "excursions.6.what_you_learn.3",
			},
			{
				text: "excursions.6.what_you_learn.4",
			},
			{
				text: "excursions.6.what_you_learn.5",
			},
			{
				text: "excursions.6.what_you_learn.6",
			},
			{
				text: "excursions.6.what_you_learn.7",
			},
			{
				text: "excursions.6.what_you_learn.8",
			},
			{
				text: "excursions.6.what_you_learn.9",
			},
		],
	},
	{
		id: "6",
		img: "/excursions/kolomenskoye.jpg",
		name: "excursions.7.title",
		age: "excursions.7.age",
		time: "excursions.7.time",
		route: "excursions.7.route",
		desc: "excursions.7.description",
		price: "excursions.7.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.7.details.1",
			},
			{
				text: "excursions.7.details.2",
			},
			{
				text: "excursions.7.details.3",
			},
		],
		what_to_expect: [
			{
				text: "excursions.7.what_to_expect.1",
			},
			{
				text: "excursions.7.what_to_expect.2",
			},
			{
				text: "excursions.7.what_to_expect.3",
			},
			{
				text: "excursions.7.what_to_expect.4",
			},
			{
				text: "excursions.7.what_to_expect.5",
			},
			{
				text: "excursions.7.what_to_expect.6",
			},
			{
				text: "excursions.7.what_to_expect.7",
			},
		],
		what_you_learn: [
			{
				text: "excursions.7.what_you_learn.1",
			},
			{
				text: "excursions.7.what_you_learn.2",
			},
			{
				text: "excursions.7.what_you_learn.3",
			},
			{
				text: "excursions.7.what_you_learn.4",
			},
			{
				text: "excursions.7.what_you_learn.5",
			},
			{
				text: "excursions.7.what_you_learn.6",
			},
			{
				text: "excursions.7.what_you_learn.7",
			},
			{
				text: "excursions.7.what_you_learn.8",
			},
			{
				text: "excursions.7.what_you_learn.9",
			},
		],
	},
	{
		id: "7",
		img: "/excursions/kolomenskoye2.jpg",
		name: "excursions.8.title",
		age: "excursions.8.age",
		time: "excursions.8.time",
		route: "excursions.8.route",
		desc: "excursions.8.description",
		price: "excursions.8.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.8.details.1",
			},
			{
				text: "excursions.8.details.2",
			},
			{
				text: "excursions.8.details.3",
			},
			{
				text: "excursions.8.details.4",
			},
			{
				text: "excursions.8.details.5",
			},
		],
		what_to_expect: [
			{
				text: "excursions.8.what_to_expect.1",
			},
			{
				text: "excursions.8.what_to_expect.2",
			},
			{
				text: "excursions.8.what_to_expect.3",
			},
			{
				text: "excursions.8.what_to_expect.4",
			},
			{
				text: "excursions.8.what_to_expect.5",
			},
			{
				text: "excursions.8.what_to_expect.6",
			},
			{
				text: "excursions.8.what_to_expect.7",
			},
			{
				text: "excursions.8.what_to_expect.8",
			},
			{
				text: "excursions.8.what_to_expect.9",
			},
			{
				text: "excursions.8.what_to_expect.10",
			},
			{
				text: "excursions.8.what_to_expect.11",
			},
		],
		what_you_learn: [
			{
				text: "excursions.8.what_you_learn.1",
			},
			{
				text: "excursions.8.what_you_learn.2",
			},
			{
				text: "excursions.8.what_you_learn.3",
			},
			{
				text: "excursions.8.what_you_learn.4",
			},
			{
				text: "excursions.8.what_you_learn.5",
			},
			{
				text: "excursions.8.what_you_learn.6",
			},
			{
				text: "excursions.8.what_you_learn.7",
			},
		],
	},
	{
		id: "8",
		img: "/excursions/pobeda.jpg",
		name: "excursions.9.title",
		age: "excursions.9.age",
		time: "excursions.9.time",
		route: "excursions.9.route",
		desc: "excursions.9.description",
		price: "excursions.9.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.9.details.1",
			},
			{
				text: "excursions.9.details.2",
			},
			{
				text: "excursions.9.details.3",
			},
			{
				text: "excursions.9.details.4",
			},
			{
				text: "excursions.9.details.5",
			},
			{
				text: "excursions.9.details.6",
			},
		],
		what_to_expect: [
			{
				text: "excursions.9.what_to_expect.1",
			},
			{
				text: "excursions.9.what_to_expect.2",
			},
		],
		what_you_learn: [
			{
				text: "excursions.9.what_you_learn.1",
			},
			{
				text: "excursions.9.what_you_learn.2",
			},
			{
				text: "excursions.9.what_you_learn.3",
			},
			{
				text: "excursions.9.what_you_learn.4",
			},
			{
				text: "excursions.9.what_you_learn.5",
			},
			{
				text: "excursions.9.what_you_learn.6",
			},
			{
				text: "excursions.9.what_you_learn.7",
			},
			{
				text: "excursions.9.what_you_learn.8",
			},
			{
				text: "excursions.9.what_you_learn.9",
			},
			{
				text: "excursions.9.what_you_learn.10",
			},
			{
				text: "excursions.9.what_you_learn.11",
			},
			{
				text: "excursions.9.what_you_learn.12",
			},
			{
				text: "excursions.9.what_you_learn.13",
			},
			{
				text: "excursions.9.what_you_learn.14",
			},
			{
				text: "excursions.9.what_you_learn.15",
			},
		],
	},
	{
		id: "9",
		img: "/excursions/army_temple.jpg",
		name: "excursions.10.title",
		age: "excursions.10.age",
		time: "excursions.10.time",
		route: "excursions.10.route",
		desc: "excursions.10.description",
		price: "excursions.10.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.10.details.1",
			},
			{
				text: "excursions.10.details.2",
			},
			{
				text: "excursions.10.details.3",
			},
			{
				text: "excursions.10.details.4",
			},
			{
				text: "excursions.10.details.5",
			},
			{
				text: "excursions.10.details.6",
			},
		],
		what_to_expect: [
			{
				text: "excursions.10.what_to_expect.1",
			},
			{
				text: "excursions.10.what_to_expect.2",
			},
			{
				text: "excursions.10.what_to_expect.3",
			},
		],
		what_you_learn: [
			{
				text: "excursions.10.what_you_learn.1",
			},
			{
				text: "excursions.10.what_you_learn.2",
			},
			{
				text: "excursions.10.what_you_learn.3",
			},
			{
				text: "excursions.10.what_you_learn.4",
			},
			{
				text: "excursions.10.what_you_learn.5",
			},
			{
				text: "excursions.10.what_you_learn.6",
			},
			{
				text: "excursions.10.what_you_learn.7",
			},
			{
				text: "excursions.10.what_you_learn.8",
			},
			{
				text: "excursions.10.what_you_learn.9",
			},
			{
				text: "excursions.10.what_you_learn.10",
			},
		],
	},
	{
		id: "10",
		img: "/excursions/new_year.jpg",
		name: "excursions.11.title",
		age: "excursions.11.age",
		time: "excursions.11.time",
		route: "excursions.11.route",
		desc: "excursions.11.description",
		price: "excursions.11.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{
				text: "excursions.11.details.1",
			},
			{
				text: "excursions.11.details.2",
			},
			{
				text: "excursions.11.details.3",
			},
			{
				text: "excursions.11.details.4",
			},
		],
		what_to_expect: [
			{
				text: "excursions.11.what_to_expect.1",
			},
			{
				text: "excursions.11.what_to_expect.2",
			},
			{
				text: "excursions.11.what_to_expect.3",
			},
			{
				text: "excursions.11.what_to_expect.4",
			},
			{
				text: "excursions.11.what_to_expect.5",
			},
			{
				text: "excursions.11.what_to_expect.6",
			},
			{
				text: "excursions.11.what_to_expect.7",
			},
			{
				text: "excursions.11.what_to_expect.8",
			},
			{
				text: "excursions.11.what_to_expect.9",
			},
			{
				text: "excursions.11.what_to_expect.10",
			},
		],
		what_you_learn: [
			{
				text: "excursions.11.what_you_learn.1",
			},
			{
				text: "excursions.11.what_you_learn.2",
			},
			{
				text: "excursions.11.what_you_learn.3",
			},
			{
				text: "excursions.11.what_you_learn.4",
			},
			{
				text: "excursions.11.what_you_learn.5",
			},
			{
				text: "excursions.11.what_you_learn.6",
			},
			{
				text: "excursions.11.what_you_learn.7",
			},
			{
				text: "excursions.11.what_you_learn.8",
			},
			{
				text: "excursions.11.what_you_learn.9",
			},
			{
				text: "excursions.11.what_you_learn.10",
			},
			{
				text: "excursions.11.what_you_learn.11",
			},
			{
				text: "excursions.11.what_you_learn.12",
			},
		],
	},
	{
		id: "11",
		img: "/excursions/christ_the_savior.jpg",
		name: "excursions.12.title",
		age: "excursions.12.age",
		time: "excursions.12.time",
		route: "excursions.12.route",
		desc: "excursions.12.description",
		price: "excursions.12.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{ text: "excursions.12.details.1" },
			{ text: "excursions.12.details.2" },
			{ text: "excursions.12.details.3" },
			{ text: "excursions.12.details.4" },
			{ text: "excursions.12.details.5" },
			{ text: "excursions.12.details.6" },
		],
		what_to_expect: [
			{ text: "excursions.12.what_to_expect.1" },
			{ text: "excursions.12.what_to_expect.2" },
			{ text: "excursions.12.what_to_expect.3" },
		],
		what_you_learn: [
			{ text: "excursions.12.what_you_learn.1" },
			{ text: "excursions.12.what_you_learn.2" },
			{ text: "excursions.12.what_you_learn.3" },
			{ text: "excursions.12.what_you_learn.4" },
			{ text: "excursions.12.what_you_learn.5" },
			{ text: "excursions.12.what_you_learn.6" },
			{ text: "excursions.12.what_you_learn.7" },
			{ text: "excursions.12.what_you_learn.8" },
			{ text: "excursions.12.what_you_learn.9" },
		],
	},
	{
		id: "12",
		img: "/excursions/savvinskoye_podvorye.jpg",
		name: "excursions.13.title",
		age: "excursions.13.age",
		time: "excursions.13.time",
		route: "excursions.13.route",
		desc: "excursions.13.description",
		price: "excursions.13.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{ text: "excursions.13.details.1" },
			{ text: "excursions.13.details.2" },
			{ text: "excursions.13.details.3" },
			{ text: "excursions.13.details.4" },
			{ text: "excursions.13.details.5" },
		],
		what_to_expect: [
			{ text: "excursions.13.what_to_expect.1" },
			{ text: "excursions.13.what_to_expect.2" },
			{ text: "excursions.13.what_to_expect.3" },
			{ text: "excursions.13.what_to_expect.4" },
			{ text: "excursions.13.what_to_expect.5" },
			{ text: "excursions.13.what_to_expect.6" },
			{ text: "excursions.13.what_to_expect.7" },
		],
		what_you_learn: [
			{ text: "excursions.13.what_you_learn.1" },
			{ text: "excursions.13.what_you_learn.2" },
			{ text: "excursions.13.what_you_learn.3" },
			{ text: "excursions.13.what_you_learn.4" },
			{ text: "excursions.13.what_you_learn.5" },
			{ text: "excursions.13.what_you_learn.6" },
		],
	},
	{
		id: "13",
		img: "/excursions/moscow_city.jpg",
		name: "excursions.14.title",
		age: "excursions.14.age",
		time: "excursions.14.time",
		route: "excursions.14.route",
		desc: "excursions.14.description",
		price: "excursions.14.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{ text: "excursions.14.details.1" },
			{ text: "excursions.14.details.2" },
			{ text: "excursions.14.details.3" },
			{ text: "excursions.14.details.4" },
			{ text: "excursions.14.details.5" },
		],
		what_to_expect: [
			{ text: "excursions.14.what_to_expect.1" },
			{ text: "excursions.14.what_to_expect.2" },
			{ text: "excursions.14.what_to_expect.3" },
			{ text: "excursions.14.what_to_expect.4" },
			{ text: "excursions.14.what_to_expect.5" },
			{ text: "excursions.14.what_to_expect.6" },
			{ text: "excursions.14.what_to_expect.7" },
			{ text: "excursions.14.what_to_expect.8" },
			{ text: "excursions.14.what_to_expect.9" },
			{ text: "excursions.14.what_to_expect.10" },
			{ text: "excursions.14.what_to_expect.11" },
			{ text: "excursions.14.what_to_expect.12" },
			{ text: "excursions.14.what_to_expect.13" },
			{ text: "excursions.14.what_to_expect.14" },
		],
		what_you_learn: [
			{ text: "excursions.14.what_you_learn.1" },
			{ text: "excursions.14.what_you_learn.2" },
			{ text: "excursions.14.what_you_learn.3" },
			{ text: "excursions.14.what_you_learn.4" },
			{ text: "excursions.14.what_you_learn.5" },
			{ text: "excursions.14.what_you_learn.6" },
			{ text: "excursions.14.what_you_learn.7" },
		],
	},
	{
		id: "14",
		img: "/excursions/love_italian.jpg",
		name: "excursions.15.title",
		age: "excursions.15.age",
		time: "excursions.15.time",
		route: "excursions.15.route",
		desc: "excursions.15.description",
		price: "excursions.15.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{ text: "excursions.15.details.1" },
			{ text: "excursions.15.details.2" },
			{ text: "excursions.15.details.3" },
			{ text: "excursions.15.details.4" },
			{ text: "excursions.15.details.5" },
		],
		what_to_expect: [
			{ text: "excursions.15.what_to_expect.1" },
			{ text: "excursions.15.what_to_expect.2" },
			{ text: "excursions.15.what_to_expect.3" },
			{ text: "excursions.15.what_to_expect.4" },
			{ text: "excursions.15.what_to_expect.5" },
			{ text: "excursions.15.what_to_expect.6" },
			{ text: "excursions.15.what_to_expect.7" },
		],
		what_you_learn: [
			{ text: "excursions.15.what_you_learn.1" },
			{ text: "excursions.15.what_you_learn.2" },
			{ text: "excursions.15.what_you_learn.3" },
			{ text: "excursions.15.what_you_learn.4" },
			{ text: "excursions.15.what_you_learn.5" },
			{ text: "excursions.15.what_you_learn.6" },
			{ text: "excursions.15.what_you_learn.7" },
			{ text: "excursions.15.what_you_learn.8" },
			{ text: "excursions.15.what_you_learn.9" },
			{ text: "excursions.15.what_you_learn.10" },
		],
	},
	{
		id: "15",
		img: "/excursions/french_moscow.jpg",
		name: "excursions.16.title",
		age: "excursions.16.age",
		time: "excursions.16.time",
		route: "excursions.16.route",
		desc: "excursions.16.description",
		price: "excursions.16.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{ text: "excursions.16.details.1" },
			{ text: "excursions.16.details.2" },
			{ text: "excursions.16.details.3" },
			{ text: "excursions.16.details.4" },
			{ text: "excursions.16.details.5" },
			{ text: "excursions.16.details.6" },
		],
		what_to_expect: [
			{ text: "excursions.16.what_to_expect.1" },
			{ text: "excursions.16.what_to_expect.2" },
			{ text: "excursions.16.what_to_expect.3" },
			{ text: "excursions.16.what_to_expect.4" },
			{ text: "excursions.16.what_to_expect.5" },
			{ text: "excursions.16.what_to_expect.6" },
			{ text: "excursions.16.what_to_expect.7" },
			{ text: "excursions.16.what_to_expect.8" },
			{ text: "excursions.16.what_to_expect.9" },
			{ text: "excursions.16.what_to_expect.10" },
			{ text: "excursions.16.what_to_expect.11" },
			{ text: "excursions.16.what_to_expect.12" },
		],
		what_you_learn: [
			{ text: "excursions.16.what_you_learn.1" },
			{ text: "excursions.16.what_you_learn.2" },
			{ text: "excursions.16.what_you_learn.3" },
			{ text: "excursions.16.what_you_learn.4" },
			{ text: "excursions.16.what_you_learn.5" },
			{ text: "excursions.16.what_you_learn.6" },
			{ text: "excursions.16.what_you_learn.7" },
			{ text: "excursions.16.what_you_learn.8" },
			{ text: "excursions.16.what_you_learn.9" },
			{ text: "excursions.16.what_you_learn.10" },
			{ text: "excursions.16.what_you_learn.11" },
		],
	},
	{
		id: "16",
		img: "/excursions/stalin_skyscrapers_car.jpg",
		name: "excursions.17.title",
		age: "excursions.17.age",
		time: "excursions.17.time",
		route: "excursions.17.route",
		desc: "excursions.17.description",
		price: "excursions.17.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{ text: "excursions.17.details.1" },
			{ text: "excursions.17.details.2" },
			{ text: "excursions.17.details.3" },
			{ text: "excursions.17.details.4" },
			{ text: "excursions.17.details.5" },
			{ text: "excursions.17.details.6" },
			{ text: "excursions.17.details.7" },
		],
		what_to_expect: [
			{ text: "excursions.17.what_to_expect.1" },
			{ text: "excursions.17.what_to_expect.2" },
			{ text: "excursions.17.what_to_expect.3" },
			{ text: "excursions.17.what_to_expect.4" },
			{ text: "excursions.17.what_to_expect.5" },
			{ text: "excursions.17.what_to_expect.6" },
			{ text: "excursions.17.what_to_expect.7" },
			{ text: "excursions.17.what_to_expect.8" },
			{ text: "excursions.17.what_to_expect.9" },
		],
		what_you_learn: [
			{ text: "excursions.17.what_you_learn.1" },
			{ text: "excursions.17.what_you_learn.2" },
			{ text: "excursions.17.what_you_learn.3" },
			{ text: "excursions.17.what_you_learn.4" },
			{ text: "excursions.17.what_you_learn.5" },
			{ text: "excursions.17.what_you_learn.6" },
			{ text: "excursions.17.what_you_learn.7" },
			{ text: "excursions.17.what_you_learn.8" },
		],
	},
	{
		id: "18",
		img: "/excursions/phontans.jpg",
		name: "excursions.18.title",
		age: "excursions.18.age",
		time: "excursions.18.time",
		route: "excursions.18.route",
		desc: "excursions.18.description",
		price: "excursions.18.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{ text: "excursions.18.details.2" },
			{ text: "excursions.18.details.3" },
			{ text: "excursions.18.details.6" },
		],
		what_to_expect: [
			{ text: "excursions.18.what_to_expect.1" },
			{ text: "excursions.18.what_to_expect.2" },
			{ text: "excursions.18.what_to_expect.3" },
			{ text: "excursions.18.what_to_expect.4" },
			{ text: "excursions.18.what_to_expect.5" },
			{ text: "excursions.18.what_to_expect.6" },
			{ text: "excursions.18.what_to_expect.7" },
		],
		what_you_learn: [
			{ text: "excursions.18.what_you_learn.1" },
			{ text: "excursions.18.what_you_learn.2" },
			{ text: "excursions.18.what_you_learn.3" },
			{ text: "excursions.18.what_you_learn.4" },
			{ text: "excursions.18.what_you_learn.5" },
		],
	},
	{
		id: "19",
		img: "/excursions/mid.jpg",
		name: "excursions.19.title",
		age: "excursions.19.age",
		time: "excursions.19.time",
		route: "excursions.19.route",
		desc: "excursions.19.description",
		price: "excursions.19.price",
		url: "https://tglink.ru/Tatiana_Prokazova",
		details: [
			{ text: "excursions.19.details.2" },
			{ text: "excursions.19.details.3" },
		],
		what_to_expect: [
			{ text: "excursions.19.what_to_expect.1" },
			{ text: "excursions.19.what_to_expect.2" },
			{ text: "excursions.19.what_to_expect.3" },
			{ text: "excursions.19.what_to_expect.4" },
			{ text: "excursions.19.what_to_expect.5" },
			{ text: "excursions.19.what_to_expect.6" },
			{ text: "excursions.19.what_to_expect.7" },
			{ text: "excursions.19.what_to_expect.8" },
			{ text: "excursions.19.what_to_expect.9" },
		],
		what_you_learn: [
			{ text: "excursions.19.what_you_learn.1" },
			{ text: "excursions.19.what_you_learn.2" },
			{ text: "excursions.19.what_you_learn.3" },
			{ text: "excursions.19.what_you_learn.4" },
			{ text: "excursions.19.what_you_learn.5" },
			{ text: "excursions.19.what_you_learn.6" },
		],
	},
];
